import { useState } from "react";
import { runGdpb } from "../api/client";
import JobLog from "../components/JobLog";

export default function GDPB() {
  const [mode, setMode]               = useState("all");
  const [sku, setSku]                 = useState("");
  const [limit, setLimit]             = useState("");
  const [update, setUpdate]           = useState(true);
  const [dryRun, setDryRun]           = useState(false);
  const [forceImages, setForceImages] = useState(false);
  const [jobId, setJobId]             = useState(null);
  const [running, setRunning]         = useState(false);
  const [error, setError]             = useState("");

  const submit = async (e) => {
    e.preventDefault();
    if (mode === "sku" && !sku.trim()) { setError("Informe o SKU."); return; }
    setError("");
    setRunning(true);
    setJobId(null);
    try {
      const body = {
        update_if_exists: update,
        dry_run: dryRun,
        force_images: forceImages,
      };
      if (mode === "sku") body.sku = sku.trim();
      if (limit) body.limit = parseInt(limit, 10);
      const { data } = await runGdpb(body);
      setJobId(data.job_id);
    } catch (err) {
      setError(err.response?.data?.detail || err.message);
      setRunning(false);
    }
  };

  return (
    <div>
      <h2 className="text-2xl font-bold text-gray-800 mb-6">GDPB — Gestão de Produtos Bling</h2>

      <div className="bg-white rounded-xl shadow p-6">
        <form onSubmit={submit} className="space-y-4">

          <div>
            <label className="block text-sm font-medium text-gray-700 mb-2">Modo</label>
            <div className="flex gap-4">
              <label className="flex items-center gap-1.5 text-sm cursor-pointer">
                <input type="radio" name="gdpb-mode" value="all" checked={mode === "all"} onChange={() => setMode("all")} />
                Todos (Exportar = SIM)
              </label>
              <label className="flex items-center gap-1.5 text-sm cursor-pointer">
                <input type="radio" name="gdpb-mode" value="sku" checked={mode === "sku"} onChange={() => setMode("sku")} />
                SKU único
              </label>
            </div>
          </div>

          {mode === "sku" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">SKU</label>
              <input
                type="text"
                value={sku}
                onChange={(e) => setSku(e.target.value)}
                placeholder="EG-FK-XXXX"
                className="w-full border border-gray-300 rounded-lg px-3 py-2 text-sm font-mono focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          {mode === "all" && (
            <div>
              <label className="block text-sm font-medium text-gray-700 mb-1">Limite (opcional)</label>
              <input
                type="number"
                value={limit}
                onChange={(e) => setLimit(e.target.value)}
                placeholder="ex: 50"
                min="1"
                className="w-32 border border-gray-300 rounded-lg px-3 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>
          )}

          <div className="space-y-2">
            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
              <input type="checkbox" checked={update} onChange={(e) => setUpdate(e.target.checked)} className="rounded" />
              Atualizar se existir
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
              <input type="checkbox" checked={forceImages} onChange={(e) => setForceImages(e.target.checked)} className="rounded" />
              Forçar re-upload de imagens
            </label>
            <label className="flex items-center gap-2 text-sm text-gray-700 cursor-pointer">
              <input type="checkbox" checked={dryRun} onChange={(e) => setDryRun(e.target.checked)} className="rounded" />
              Simulação (dry-run — não envia para a API)
            </label>
          </div>

          {error && <p className="text-red-500 text-sm">{error}</p>}

          <button
            type="submit"
            disabled={running && !jobId}
            className="bg-blue-800 hover:bg-blue-700 disabled:bg-gray-300 text-white font-semibold px-6 py-2 rounded-lg text-sm transition-colors"
          >
            Executar
          </button>
        </form>

        <JobLog jobId={jobId} onDone={() => setRunning(false)} />
      </div>
    </div>
  );
}
